import { Suspense, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  MenuItem,
  Fab,
  ListItemIcon,
  Divider,
  Drawer,
  List,
  IconButton,
  Menu,
} from "@mui/material";
import {
  Dashboard,
  CreditCard,
  People,
  Logout,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { CompanyLogo } from "@/components/companyLogo";
import { ADMIN_DRAWER_WIDTH } from "@/const";
import { useAuthContext } from "@/context/AuthContext";
import RecaptchaTerms from "@/components/recaptchaTerms";
import DrawerItem from "../common/DrawerItem";

const profileIconStyles = {
  backgroundColor: "white",
  color: "black",
  "&:hover": {
    backgroundColor: "#e0e0e0",
    cursor: "pointer",
    boxShadow: "none",
  },
  pl: { xs: 0 },
  boxShadow: "none",
  padding: 0,
};

export const AdminLayout = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();

  //user menu
  const [anchorEl, setAnchorEl] = useState(null);
  const openUserMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  //drawer
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        <DrawerItem path="/admin" icon={<Dashboard />} text="Dashboard" />
        {user.role === "super-admin" ? (
          <DrawerItem
            path="/admin/companies"
            icon={<People />}
            text="Companies"
          />
        ) : (
          <DrawerItem
            path="/admin/regions"
            icon={<People />}
            text="Base Regions"
          />
        )}

        <DrawerItem path="/shop" icon={<CreditCard />} text="Shop" />
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: 9999,
          width: { sm: `calc(100% - ${ADMIN_DRAWER_WIDTH}px)` },
          ml: { sm: `${ADMIN_DRAWER_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ maxWidth: { xs: "auto" }, width: "100%" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="white"
            noWrap
            sx={{ marginTop: "8px" }}
          >
            <div
              onClick={() => navigate("/admin")}
              style={{ cursor: "pointer" }}
            >
              <CompanyLogo />
            </div>
          </Typography>
          <div style={{ flexGrow: 1 }} />
          <div style={{ color: "white" }}>
            <Fab
              size="small"
              variant="extended"
              onClick={openUserMenu}
              sx={profileIconStyles}
            >
              <div style={{ margin: 10, fontSize: 15, textAlign: "center" }}>
                {user.firstName?.[0]}
                {user.lastName?.[0]}
              </div>
            </Fab>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              // keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              sx={{ marginTop: 6 }}
              onClose={() => setAnchorEl(null)}
            >
              <div style={{ textAlign: "left", padding: 8, cursor: "default" }}>
                <div>
                  Hello, {user.firstName} {user.lastName}!
                </div>
                <div style={{ color: "grey" }}>{user.email}</div>
              </div>
              <Divider />
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  navigate("/logout");
                }}
              >
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: ADMIN_DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: ADMIN_DRAWER_WIDTH,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: ADMIN_DRAWER_WIDTH,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100%",
          minHeight: "100vh",
          overflow: "auto",
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </Container>
        <RecaptchaTerms />
      </Box>
    </Box>
  );
};
